<template>
  <div class="com-container relative">
    <img src="../assets/images/list/bg.jpg" alt width="100%" />
    <div class="main-box">
      <div class="relative">
        <div class="top-title">{{kechengInfo.title}}</div>

        <div class="swiper-box">
          <div class="recommendPage">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item, index) in listData" :key="index">
                <div class="s-item">
                  <div class="course-box" v-for="(item2, index2) in item" :key="index2">
                    <div @click="showCourse(index,index2)" class="pointer">
                      <img src="../assets/images/list/course1.png" alt class="c-img" />
                      <div class="c-title">{{item2.title_keshi}</div>
                    </div>
                  </div>
                </div>
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination" style="bottom:50px"></div>
              <!-- <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>-->
            </swiper>
          </div>

          <div class="clear"></div>
        </div>
      </div>
      <!-- relavive end -->
    </div>
    <!-- main-box end -->
    <!-- 底部 -->
    <Footer></Footer>
    <!-- 右侧弹窗 -->
    <div id="right" :style="right_px">
      <div class="r-left" @click="rightShow()">
        <el-image :src="right_img" alt class="f-btn" width="100%"></el-image>
      </div>
      <div class="r-right">
        <div class="r-item">返回</div>
        <div class="r-item">窗口化</div>
        <div class="r-item">最小化</div>
        <div class="r-item">节拍器</div>
        <div class="r-item">批注</div>
        <div class="r-item">白板</div>
      </div>
    </div>

    <!-- 课程内容 -->
    <el-dialog
      :title="courseInfo.title_keshi"
      :visible.sync="dialogVisible_course"
      width="100%"
      :show-close="false"
      top='100px'
      custom-class="com-dialog"
    >
      <div class="com-info-box relative">
        <div class="btn-close" @click="dialogVisible_course = false">
          <img src="../assets/images/other/btn_close.png" alt width="100%" />
        </div>
        <!-- <p class="info">{{courseInfo.title_keshi}}</p> -->
        <div class="cov-video-container">
          <object
            width="100%"
            classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
            codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=9,0,28,0"
            id="abcdef"
          >
            <param value="high" name="quality" />
            <param value="transparent" name="wmode" />
            <embed
              width="100%"
              name="abcdef"
              fullscreen="yes"
              wmode="transparent"
              type="application/x-shockwave-flash"
              pluginspage="http://www.adobe.com/shockwave/download/download.cgi?P1_Prod_Version=ShockwaveFlash"
              quality="high"
              src="https://www.wiking3d.com/123wechat456/1.swf"
            />
          </object>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src

/* eslint-disable */
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Footer from "@/components/Footer.vue";

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    Footer,
  },
  data() {
    return {
      listData: [],
      map: [],
      dialogVisible_course: false,
      right_px: "right:-130px",
      right_show: 0,
      right_img: require("../assets/images/right/left.png"),
      swiperOption: {
        loop: false, //循环
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },

        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          //分页
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            //自定义分页的按钮
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          },
        },
      },
      courseInfo: "",
      kechengInfo: "",
    };
  },
  mounted() {
    // 登录判定
    if (this.getCookie("account_id")) {
      this.setCookie("account_id", this.getCookie("account_id"), 120);
    } else {
      this.$message({
        message: "请先登录",
        type: "warning",
        duration: 1000,
        onClose: function () {
          that.$router.push({ path: "/login" });
        },
      });
    }

    this.$axios({
      method: "GET",
      url: this.apiTp5Url + "/getCourseInfo",
      params: {
        course_id: this.$route.params.course_id,
      },
    })
      .then((response) => {
        console.log("返回:" + JSON.stringify(response.data));
        //this.listData = response.data.listData.slice(0, 12);
        this.kechengInfo = response.data.courseInfo;

        var chunk = 10;
        var len = response.data.listData.length;

        var result = [];
        for (let i = 0; i < len; i += chunk) {
          result.push(response.data.listData.slice(i, i + chunk)); // 每10项分成一组
        }

        this.listData = result;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    // 显示右侧按钮
    rightShow() {
      if (this.right_show == 1) {
        this.$set(this, "right_px", "right:-130px;transition: all .3s ease;");
        this.$set(this, "right_show", 0);
        this.$set(
          this,
          "right_img",
          require("../assets/images/right/left.png")
        );
      } else {
        this.$set(this, "right_px", "right:0px;transition: all .3s ease;");
        this.$set(this, "right_show", 1);
        this.$set(
          this,
          "right_img",
          require("../assets/images/right/right.png")
        );
      }
    },
    // 获取下级分类
    getNewCourseList() {
      this.$axios({
        method: "GET",
        url: this.apiTp5Url + "/getCourseList",
        params: {
          kecheng_category_id: this.kecheng_category_id,
          category_one_id: this.oneCategoryVal,
          category_two_id: this.twoCategoryVal,
          category_three_id: this.threeCategoryVal,
        },
      })
        .then((response) => {
          //console.log("返回:" + JSON.stringify(response.data));

          var chunk = 10;
          var len = response.data.listData.length;

          var result = [];
          for (let i = 0; i < len; i += chunk) {
            result.push(response.data.listData.slice(i, i + chunk)); // 每10项分成一组
          }

          this.listData = result;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //显示课程弹窗
    showCourse(index, index2) {
      this.dialogVisible_course = true;
      this.courseInfo = this.listData[index][index2];
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  watch: {
    oneCategoryVal: function (nval, oval) {
      this.$axios({
        method: "GET",
        url: this.apiTp5Url + "/getSonCorseCategoryList",
        params: {
          parent_id: nval,
        },
      })
        .then((response) => {
          console.log("返回:" + JSON.stringify(response.data.listData));
          if (response.data.count > 0) {
            this.oneCategoryVal = nval;
            this.TwoCategoryShow = true;
            this.TwoCategory = response.data.listData;
            this.getNewCourseList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    twoCategoryVal: function (nval, oval) {
      //判断当前分类是否有课程，无课程不会返回
      this.$axios({
        method: "GET",
        url: this.apiTp5Url + "/getSonCorseCategoryList",
        params: {
          parent_id: nval,
        },
      })
        .then((response) => {
          console.log("返回:" + JSON.stringify(response.data.listData));
          if (response.data.count > 0) {
            this.twoCategoryVal = nval;
            this.ThreeCategoryShow = true;
            this.ThreeCategory = response.data.listData;
            this.getNewCourseList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.main-box {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
.com-container {
  max-width: 1920px;

  margin: 0 auto;
  /* background: url("../assets/images/index/bg.jpg") no-repeat center top;
  background-size: 100% auto; */
}

.top-title {
  text-align: center;
  padding: 10px;
  font-family: newfont;
  font-size: 50px;
  line-height: 100px;
  color: #fff;
  text-shadow: 0.2rem 0rem 0.5rem #201e89, -0.2rem 0rem 0.5rem #201e89,
    0rem 0.2rem 0.5rem #201e89, 0rem -0.2rem 0.5rem #201e89;
}
/* 搜索框 */
.search-box {
  height: 40px;
  margin-bottom: 30px;
}
.search-box .item {
  width: 160px;
  float: left;
  margin-right: 20px;
}
.search-box .item img {
  width: 100%;
}
/* 轮播图 */
.swiper-box {
  margin: 50px 200px;
}
.recommendPage .swiper-container {
  position: relative;
  width: 100%;
  height: 680px;
  background: url("../assets/images/list/bk.png") no-repeat center top;
  background-size: 100% auto;
}

.recommendPage .swiper-container .swiper-slide {
  width: 100%;
  color: #000;
  font-size: 16px;
  text-align: center;
}
.recommendPage .swiper-container .swiper-slide .s-item {
  margin: 40px 0;
  text-align: center;
}
.s-item .course-box {
  width: 200px;
  float: left;
  text-align: center;
  margin-left: 80px;
  margin-top: 30px;
  position: relative;
}
.s-item .course-box .c-img {
  width: 100%;
}
.s-item .course-box .c-title {
  font-size: 18px;
  color: #fff;
  line-height: 40px;
  position: absolute;
  bottom: 75px;
  width: 100%;
  color: #201e89;
}
.s-item .course-box .c-title-burrent {
  background: rgba(0, 0, 0, 0.2);
  width: 70%;
  margin-left: 15%;
}
.s-item .course-box:hover .c-title {
  color: #0080ff;
}
/* 左右箭头 */
.swiper-button-prev {
  left: -10px;
  background: url("../assets/images/index/left.png") no-repeat center top;
  background-size: 40px;
  width: 60px;
  height: 60px;
}
.swiper-button-next {
  right: 0px;
  background: url("../assets/images/index/right.png") no-repeat center top;
  background-size: 40px;
  width: 60px;
  height: 60px;
}
/* 分页按钮 */
.swiper-pagination-bullet-custom {
  width: 30px;
  height: 30px;
  border-radius: 5px;
}
.swiper-pagination-bullet-custom.swiper-pagination-bullet-active {
  color: #fff;
  background: #a11703;
}

/* 右侧弹窗 */
#right {
  position: fixed;
  top: 20%;

  background: url("../assets/images/right/bg.png") no-repeat center top;
  background-size: 100%;
  height: 600px;
  width: 180px;
  z-index: 99999;
  padding-top: 20px;
}
#right .r-left {
  width: 30px;
  float: left;
  padding-top: 140px;
  margin-left: 20px;
}
#right .r-right {
  float: right;
  height: 100%;
  width: 100px;
}
#right .r-right .r-item {
  background: #fff;
  color: #2eb8be;
  clear: both;
  border-radius: 6px;
  margin-top: 15px;
  width: 80px;
  text-align: center;
  line-height: 35px;
  cursor: pointer;
}
</style>

<style >
/* 选择框 */
.myselect {
  color: #fff;
}
.myselect input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #fff;
}
.myselect input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #fff;
}
.myselect input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #fff;
}
.myselect input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #fff;
}
.myselect .el-input__inner {
  /*border-radius: 20px;
  box-shadow: 0 0 5px #fff;
  background-image: linear-gradient(to bottom, #b9aff2, #c29cf4);
  color: #fff;
  border: 3px solid #efefef;*/
}
.myselect .el-input__inner:focus {
  /*border: 3px solid #efefef;*/
}
.myselect .el-input__suffix-inner .el-input__icon {
  color: #fff;
}

/* 公用弹窗 */
.com-dialog {
  text-align: left;
  background: none;
}
.el-dialog {
  background: none;
  border: none;
  box-shadow: none;
}

.el-dialog__header {
}
.el-dialog__header .el-dialog__title {
  font-family: newfont;
  color: #fff;
  font-size: 40px;
  text-shadow: 0 0 3px salmon;
}
.el-dialog__body {
  /*background: rgba(255, 255, 255, 0.8);
  height: 250px;
  border-radius: 8px;
  height: 80%;*/
}
.el-dialog__body a {
  color: #444;
}
.el-dialog__body a:hover {
  color: slateblue;
}

.el-dialog__body .com-info-box .info {
  line-height: 25px;
  font-size: 16px;
}

.el-dialog__body .com-info-box .info .i-left {
  display: inline-block;
  width: 120px;
  text-align: justify;
  text-align-last: justify;
}
/* 关闭按钮 */
.btn-close {
  position: absolute;
  top: -80px;
  right: -35px;
  width: 50px;
}
.dialog-footer {
  text-align: center;
}
.dialog-footer img {
  display: inline-block;
  margin: 0 15px;
}
</style>
